import { RequestResponse } from "../../DTO/requestResponse";
import { Request } from "../../CONSTANTS/request";
import { consultaTrackingDetalleDto } from "./consultaTrackingDetalle.dto";
import { MICROSERVICIOS } from "../../CONSTANTS/constants";

import * as ONLY from 'is-online';


export default class Tracking {


    // Tracking.detalle
    static async detalle(detalle: consultaTrackingDetalleDto): Promise<RequestResponse> {


        return Conectividad("detalle", detalle);


    }
}



async function Conectividad(direccion: any, body: any) {
    console.log(MICROSERVICIOS.TRACKING_DETALLE + direccion);

    if (await ONLY.default()) {

        return new Request(MICROSERVICIOS.TRACKING_DETALLE).post(direccion, body);

    } else {

        return {
            status: -1,
            description: "No fue posible obtener información, No hay conexión a Internet",
            data: null,
            error: "No fue posible obtener información, No hay conexion a Internet",
        };

    }

}